const RYSN_SHOP_ENTRY_KEY = 'rysnShopButtonEntry';

document.addEventListener('click', (event) => {
  const shopButton = event.target.closest('.rysn-shop-pulse-button');
  if (!shopButton || !shopButton.href) return;

  try {
    sessionStorage.setItem(RYSN_SHOP_ENTRY_KEY, 'true');
  } catch (_error) {
    // Navigation still works if storage is unavailable.
  }
});
